

export default function Card({ children, style = {} }) {
  return (
    <div style={{
      background: "#fff", borderRadius: 16, padding: 32,
      boxShadow: "0 2px 20px rgba(0,0,0,0.06)", border: "1px solid #f1f5f9",
      transition: "box-shadow 0.2s, transform 0.2s", ...style
    }}
      onMouseOver={e => { e.currentTarget.style.boxShadow = "0 8px 40px rgba(37,99,235,0.12)"; e.currentTarget.style.transform = "translateY(-3px)"; }}
      onMouseOut={e => { e.currentTarget.style.boxShadow = "0 2px 20px rgba(0,0,0,0.06)"; e.currentTarget.style.transform = "translateY(0)"; }}
    >{children}</div>
  );
}
